<div class="mail-viewer iframe-container" [ngClass]="{'borderless': borderless}">
   <iframe class="url-preview" [src]="url"></iframe>
</div>